export default ".radio-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.label-GED {\n  margin: 0 1.5rem 0 0.5rem;\n  color: black;\n}"